/**
* AudioContent.js
* 
* Created on Oct 8, 2013, 2:19:32 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/

import Content from "./Content";
import ContentFactory from "./ContentFactory";
import ContentTypes from "./ContentTypes";
import ENGLanguagePackContentType from "./ENGLanguagePackContentType";


export default class AudioContent extends Content {
        constructor(languagePack, contentID, audio, label) {
            super(AudioContent.NAME, ContentTypes.TYPE_AUDIO, label, languagePack, contentID);
            this.setAudio(audio);
        }
        remove() {
            this.removeLanguagePackContent(AudioContent.AUDIO_LABEL, ENGLanguagePackContentType.AUDIO);
            super.remove();
        }
        clone() {
            var clone = ContentFactory.getContent(ContentTypes.TYPE_AUDIO, this.getLanguagePack());
            clone.setContentID(this.getContentID());
            clone.setAudio(this.getAudio());
            return clone;
        }
        getAudio() {
            return this.getLanguagePackContent(AudioContent.AUDIO_LABEL, ENGLanguagePackContentType.AUDIO);
        }
        setAudio(value) {
            this.setLanguagePackContent(AudioContent.AUDIO_LABEL, ENGLanguagePackContentType.AUDIO, value);
        }
        convertToObject() {
            return this.getObject([]);
        }
        getDescriptionLabel() {
            var label;
            label = this.audio.toString();
            if (isNull(label) || label === "") {
                label = "Audio: <NO AUDIO>";
            }

            else {
                label = "Audio: " + label;
            }
            return label;
        }
    }
    
    AudioContent.NAME = "Audio"; 
    AudioContent.TYPE = "engAudioContent";
    AudioContent.AUDIO_LABEL = "audio";
    

    
    
    